import { useContext, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { UserContext } from './contexts/UserContext';

const AdminApp = () => {
	const { user } = useContext(UserContext);
	const navigate = useNavigate();

	const isAdmin = user?.is_admin;

	useEffect(() => {
		if (isAdmin) return;

		navigate('/');
	}, [user, isAdmin]);

	return <Outlet />;
};

export default AdminApp;
